import React, { Component } from 'react'
import { localize, getLocale } from '../../util/Localizer'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import RBButton from '../../controls/RBButton'
import DialogStyles from '../../styles/components/dialog'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { withStyles } from '@material-ui/core/styles'
import vi from '../../versionInfo'
import auth from '../../auth/Auth'

class About extends Component {
  constructor () {
    super()
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.renderSession = this.renderSession.bind(this)
    this.state = {
      open: false
    }
  }
  handleOpen (e) {
    e.preventDefault()
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }

  renderSession () {
    if (auth.sessionId) { return (<small>Session Id: {auth.sessionId}</small>) } else { return null }
  }

  render () {
    const actions = [
      <RBButton
        key='close'
        variant='outlined'
        label={localize('common.contactus.close')}
        primary={false}
        onClick={this.handleClose}
      />
    ]
    const loc = getLocale()
    const { appContent = {} } = this.props
    const { contentItemText = {} } = appContent
    const { content = '' } = contentItemText[loc] || {}
    return (
      <div>
        {this.props.type === 'menu'
          ? <ListItem button onClick={this.handleOpen} >
            <ListItemText primary={localize('common.about.title')} />
          </ListItem>
          : <a href='' id='about' onClick={this.handleOpen}>{localize('common.about.title')}</a>}
        <Dialog
          className={this.props.classes.aboutDialog}
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle>{localize('common.about.title')}</DialogTitle>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: content }}/>
            <div>
              <small>Version: {vi}</small>
              <br />
              {this.renderSession()}
            </div>
            <DialogActions>{actions}</DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

const styles = {
  ...DialogStyles
}

export default withStyles(styles)(About)



// WEBPACK FOOTER //
// ./src/widgets/common/About.js